import { Box, Grid, StyleRules, withStyles } from '@material-ui/core'
import React, { Component } from 'react';
import dotCircleImage from "../assets/dotCircleCodezzy.png";
import educationImage from "../assets/educationCodezzy.png";
import secondHeroUnderline from "../assets/herosectionUnderlineVector.png";

interface Props {
    classes: any,
    heading: string,
    cardClass: string,
    highlight: any,
    secondHerosectionTitleClassName?: string,
    secondHerosectionClassName?: string,
    secondHerosectionMessage?: string,
    secondHerosectionBody?: string,
    secondHerosectionUnderlined?: string,
}

class SecondHerosection extends Component<Props>{

    rendersecondHerosection = () => {
        const { classes } = this.props;
        // const cardClass = this.props.cardClass;
        return (
            <Box className={`${classes.secondHerosection} ${this.props.secondHerosectionBody}`}>
                <Box className={classes.secondHerosectionUpperBody}>
                    <Box className={classes.secondHerosectionContent}>
                        <Box className={this.props.secondHerosectionTitleClassName}>{this.props.heading}</Box>
                        <Box className={this.props.secondHerosectionUnderlined}>
                            <img src={secondHeroUnderline} alt="secondUnderline" className={classes.secondHerosectionUnderline} />
                        </Box>
                        {/* <Box className={classes.secondHerosectionMessage}><Box component="span" className={classes.secondHerosectionSpan}>{this.props.highlight}</Box> is an interactive learning platform</Box> */}
                        <Box className={this.props.secondHerosectionClassName}><Box component="span" className={classes.secondHerosectionSpan}>{this.props.highlight}</Box>{this.props.secondHerosectionMessage}</Box>
                        {/* <button className={classes.secondHerosectionButton}>Get Free Demo</button> */}
                    </Box>
                    <Box className={classes.secondHerosectionImgBody}>
                        <Box className={classes.secondHerosectionFirstImg}>
                            <img className={classes.secondHerosectionFirstImage} src={dotCircleImage} alt="educationImage" />
                        </Box>
                        <Box className={classes.secondHerosectionSecondImg}>
                            <img className={classes.secondHerosectionSecondImage} src={educationImage} alt="educationImage" />
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }

    render() {
        const { classes } = this.props;
        // console.log(classes);
        // const cardClass = this.props.cardClass;
        return (
            <Grid container className={classes.gridContain}>
                <Grid lg={12} md={12} sm={12} xs={12} className={`${classes.gridHero}`}>
                    {this.rendersecondHerosection()}
                </Grid>
            </Grid>
        )
    }
}

const style: StyleRules = ({
    gridHero: {
        width: "100%",
        height: "100%",
        "& .SecondHerosection-secondHerosectionBodyFirst": {
            width: "100%",
            padding: "0px 130px",
            backgroundColor: "#F8EBDA",
            margin: "0px 0px 0px"
        },

        "& .SecondHerosection-secondHerosectionBodySecond": {
            width: "100%",
            height: "630px",
            padding: "0px 130px",
            backgroundColor: "#F8EBDA",
            margin: "0px 0px 0px",
        },
    },

    gridHH: {
        marginTop: "-150px",
        paddingBottom: "30px",
    },

    gridContain: {
        "& .SecondHerosection-secondHerosectionLeftCards": {
            height: "270px",
            padding: "0px 130px",

            "& >*:nth-child(1)": {
                justifyContent: "left",
                "& >*:nth-child(1)": {
                    margin: "0px 30px 0px 0px",
                },

                "& >*:nth-child(2)": {
                    margin: "0px 30px",
                },

                "& >*:nth-child(3)": {
                    margin: "0px 30px",
                },
            },
        },

        "& .SecondHerosection-secondHerosectionCenterCards": {
            height: "270px",
            padding: "0px 130px",

            "& >*:nth-child(1)": {
                justifyContent: "center",

                "& >*:nth-child(1)": {
                    margin: "0px 30px",
                },

                "& >*:nth-child(2)": {
                    margin: "0px 30px",
                },

                "& >*:nth-child(3)": {
                    margin: "0px 30px",
                },
            },
        },

        "& .SecondHerosection-secondHerosectionHideCards": {
            width: "100%",
            display: "none"
        },
    },

    secondHerosectionUpperBody: {
        width: "100%",
        height: "700px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: "70px 0px"
    },

    secondHerosectionContent: {
        width: "50%",
        paddingTop: "30px",
        "& .SecondHerosection-secondHerosectionFirstTitle": {
            color: "#44AEF7",
            fontFamily: "Nunito",
            fontSize: "32px",
            fontWeight: 700,
            padding: "0px 5px",
        },

        "& .SecondHerosection-secondHerosectionSecondTitle": {
            color: "#44AEF7",
            fontFamily: "Nunito",
            fontSize: "96px",
            fontWeight: 700,
            padding: "0px 5px",
            lineHeight: "62.65px"
        },

        "& .SecondHerosection-secondHerosectionThirdUnderlined": {
            width: "240px",
            margin: "0px 12px",
            border: "1px",

            "& >*:nth-child(1)": {
                width: "100%",
                height: "100%",
            }
        },

        "& .SecondHerosection-secondHerosectionFourthUnderlined": {
            width: "340px",
            margin: "0px 12px",
            border: "1px",

            "& >*:nth-child(1)": {
                width: "100%",
                height: "100%",
            }
        },

        "& .SecondHerosection-secondHerosectionFirstMessage": {
            width: "550px",
            fontFamily: "Nunito",
            fontSize: "64px",
            fontWeight: 800
        },

        "& .SecondHerosection-secondHerosectionSecondMessage": {
            width: "450px",
            fontFamily: "Nunito",
            fontSize: "26px",
            fontWeight: 400,
            padding: "20px 0px 0px"
        },

    },

    secondHerosectionSpan: {
        color: "#B557FE",
    },

    secondHerosectionButton: {
        width: "224px",
        height: "62.28px",
        background: "linear-gradient(89.65deg, #074CBA 2.14%, rgba(13, 106, 252, 0.988235) 99.74%)",
        color: "#ffffff",
        margin: "40px 0px",
        borderRadius: "6px",
        border: "none",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: 700,
        textTransform: "uppercase"
    },

    secondHerosectionImgBody: {
        width: "50%",
        position: "relative",
    },

    secondHerosectionFirstImg: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "430px",
        height: "430px",
        zIndex: 8,
    },

    secondHerosectionFirstImage: {
        width: "100%",
        height: "100%",
    },

    secondHerosectionSecondImg: {
        width: "400px",
        height: "280px",
        position: "absolute",
        top: "70px",
        left: "150px",
        zIndex: 10,
    },

    secondHerosectionSecondImage: {
        width: "100%",
        height: "100%",
    },

    "@media screen and (min-width: 1024px) and (max-width: 1440px)": {
        gridContain: {
            "& .SecondHerosection-secondHerosectionCenterCards": {
                padding: "0px 80px",
            },
        },

        secondHerosectionContent: {
            "& .SecondHerosection-secondHerosectionFirstTitle": {
                fontSize: "20px",
            },

            "& .SecondHerosection-secondHerosectionSecondTitle": {
                // fontSize: "64px",
                fontSize: "100px",
                lineHeight: "60px",
            },

            // "& .SecondHerosection-secondHerosectionThirdUnderlined": {
            //     width: "160px",
            //     margin: "0px 12px",
            //     border: "1px",

            //     "& >*:nth-child(1)": {
            //         width: "100%",
            //         height: "100%",
            //     }
            // },
            
            "& .SecondHerosection-secondHerosectionFourthUnderlined": {
                width: "350px !important",
                margin: "0px 12px",
                border: "1px",
                "& >*:nth-child(1)": {
                    width: "100%",
                    height: "100%",
                }
            },

            "& .SecondHerosection-secondHerosectionFirstMessage": {
                width: "95%",
                fontSize: "48px",
            },

            "& .SecondHerosection-secondHerosectionSecondMessage": {
                width: "400px",
                fontSize: "20px",
            }
        },

        secondHerosectionButton: {
            width: "178.63px",
            height: "56.11px",
            fontSize: "16px"
        },

        secondHerosectionFirstImg: {
            width: "340px",
            height: "340px",
        },

        secondHerosectionSecondImg: {
            width: "300px",
            height: "220px",
            left: "120px",
        },

        secondHerosectionLowerBody: {
            padding: "0px",
            justifyContent: "space-evenly",
        },

    },

    "@media screen and (min-width: 768px) and (max-width: 1023px)": {
        gridHero: {
            "& .SecondHerosection-secondHerosectionBodyFirst": {
                padding: "0px 80px",
            },

            "& .SecondHerosection-secondHerosectionBodySecond": {
                padding: "0px 80px",
            },
        },

        gridContain: {
            "& .SecondHerosection-secondHerosectionCenterCards": {
                padding: "0px 80px",
            },
        },

        secondHerosectionBody: {
            height: "600px",
            padding: "0px 50px"
        },

        secondHerosectionUpperBody: {
            padding: "50px 0px 20px"
        },

        secondHerosectionContent: {
            "& .SecondHerosection-secondHerosectionFirstTitle": {
                fontSize: "20px",
            },

            "& .SecondHerosection-secondHerosectionSecondTitle": {
                fontSize: "50px",
                lineHeight: "25.3px",
            },

            "& .SecondHerosection-secondHerosectionThirdUnderlined": {
                width: "120px",
                margin: "0px 12px",
                border: "1px",
                "& >*:nth-child(1)": {
                    width: "100%",
                    height: "100%",
                }
            },

            "& .SecondHerosection-secondHerosectionFourthUnderlined": {
                width: "170px",
                margin: "0px 12px",
                border: "1px",
                "& >*:nth-child(1)": {
                    width: "100%",
                    height: "100%",
                }
            },

            "& .SecondHerosection-secondHerosectionFirstMessage": {
                width: "95%",
                fontSize: "40px",
            },

            "& .SecondHerosection-secondHerosectionSecondMessage": {
                width: "320px",
                fontSize: "18px",
            }
        },

        secondHerosectionButton: {
            width: "178.63px",
            height: "56.11px",
            fontSize: "16px"
        },

        secondHerosectionFirstImg: {
            width: "320px",
            height: "320px",
        },

        secondHerosectionSecondImg: {
            width: "270px",
            height: "170px",
            left: "60px",
        },
    },

    "@media screen and (min-width: 300px) and (max-width: 767px)": {
        gridHero: {
            "& .SecondHerosection-secondHerosectionBodyFirst": {
                padding: "0px 10px",
            },

            "& .SecondHerosection-secondHerosectionBodySecond": {
                padding: "0px 10px",
            },
        },

        gridContain: {
            "& .SecondHerosection-secondHerosectionCenterCards": {
                padding: "0px 80px",
            },
        },

        gridHH: {
            marginTop: "0px",
            height: "800px",
        },

        secondHerosectionBody: {
            height: "700px",
            padding: "0px 20px",
        },

        secondHerosectionUpperBody: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            padding: "10px 0px 60px"
        },

        secondHerosectionContent: {
            width: "100%",
            textAlign: "center",
            "& .SecondHerosection-secondHerosectionFirstTitle": {
                fontSize: "16px",
                padding: "0px",
            },
            "& .SecondHerosection-secondHerosectionSecondTitle": {
                fontSize: "16px",
                padding: "0px",
                lineHeight: "0px",
            },
            "& .SecondHerosection-secondHerosectionThirdUnderlined": {
                width: "45px",
                margin: "0px auto",
                border: "1px",
                "& >*:nth-child(1)": {
                    width: "100%",
                    height: "100%",
                }
            },
            "& .SecondHerosection-secondHerosectionFourthUnderlined": {
                width: "60px",
                margin: "0px auto",
                border: "1px",
                "& >*:nth-child(1)": {
                    width: "100%",
                    height: "100%",
                }
            },
            "& .SecondHerosection-secondHerosectionFirstMessage": {
                width: "100%",
                fontSize: "20px",
                padding: "15px 0px 0px",
            },
            "& .SecondHerosection-secondHerosectionSecondMessage": {
                width: "100%",
                fontSize: "20px",
                padding: "15px 0px 0px",
            }
        },

        secondHerosectionButton: {
            width: "130px",
            height: "40px",
            fontSize: "12px",
            margin: "20px 0px 30px"
        },

        secondHerosectionImgBody: {
            width: "100%",
            height: "250px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },

        secondHerosectionFirstImg: {
            width: "250px",
            height: "250px",
            top: "auto",
            left: "auto"
        },

        secondHerosectionSecondImg: {
            width: "220px",
            height: "150px",
            top: "30px",
            left: "auto",
        },

        secondHerosectionLowerBody: {
            height: "420px",
            flexDirection: "column",
            padding: "0px",
            margin: "0px"
        },
    }
})

export default withStyles(style)(SecondHerosection);